import { useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Step1.css";

const Step1 = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onSkipIAlreadyClick = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const onButtonDesktopPrimaryClick = useCallback(() => {
    navigate("/step2");
  }, [navigate]);

  const onButtonDesktopSecondaryClick = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  return (
    <div className="step1-div">
      <div className="frame-div36">
        <div className="logo1-div2" onClick={onLogo1ContainerClick}>
          <img className="vector-icon55" alt="" src="../vector55.svg" />
          <img className="vector-icon56" alt="" src="../vector56.svg" />
          <img className="vector-icon57" alt="" src="../vector57.svg" />
          <img className="vector-icon58" alt="" src="../vector58.svg" />
          <img className="vector-icon59" alt="" src="../vector59.svg" />
          <img className="vector-icon60" alt="" src="../vector60.svg" />
          <img className="vector-icon61" alt="" src="../vector61.svg" />
          <img className="vector-icon62" alt="" src="../vector62.svg" />
          <img className="vector-icon63" alt="" src="../vector63.svg" />
          <img className="vector-icon64" alt="" src="../vector64.svg" />
          <img className="vector-icon65" alt="" src="../vector65.svg" />
          <img className="vector-icon66" alt="" src="../vector66.svg" />
          <img className="vector-icon67" alt="" src="../vector67.svg" />
          <img className="vector-icon68" alt="" src="../vector68.svg" />
          <img className="vector-icon69" alt="" src="../vector69.svg" />
          <img className="vector-icon70" alt="" src="../vector70.svg" />
          <img className="vector-icon71" alt="" src="../vector71.svg" />
          <img className="vector-icon72" alt="" src="../vector72.svg" />
          <img className="vector-icon73" alt="" src="../vector73.svg" />
          <img className="vector-icon74" alt="" src="../vector74.svg" />
          <img className="vector-icon75" alt="" src="../vector75.svg" />
          <img className="vector-icon76" alt="" src="../vector76.svg" />
          <img className="vector-icon77" alt="" src="../vector77.svg" />
          <img className="vector-icon78" alt="" src="../vector78.svg" />
          <img className="vector-icon79" alt="" src="../vector79.svg" />
          <b className="shuleeazy-b2">ShuleEazy</b>
        </div>
      </div>
      <div className="frame-div37">
        <b className="the-parent-will-be-responsible">Step 1 of 3</b>
        <b className="join-shuleeazy-as-a">Join ShuleEazy as a:</b>
      </div>
      <div className="frame-div38">
        <div className="card-div">
          <div className="frame-div39">
            <img className="school-icon" alt="" src="../school.svg" />
          </div>
          <b className="parent-b">Parent</b>
          <div className="frame-div40">
            <div className="the-parent-will-be-responsible">
              <p className="the-parent-will">
                The parent will be responsible of purchasing the courses for
                their
              </p>
              <p className="children-p">children</p>
            </div>
          </div>
          <Form.Check
            className="ellipse-formcheck"
            name="step1"
            id="step1"
            type="radio"
          />
        </div>
        <div className="card-div1">
          <div className="frame-div39">
            <img className="school-icon" alt="" src="../student2.svg" />
          </div>
          <b className="parent-b">Student</b>
          <div className="frame-div40">
            <div className="the-parent-will-be-responsible">
              <p className="the-parent-will">Students between 4 and 18 years</p>
              <p className="the-parent-will">
                old will be able to access classses
              </p>
              <p className="children-p">and courses</p>
            </div>
          </div>
          <Form.Check
            className="ellipse-formcheck"
            name="step1"
            id="step1"
            type="radio"
          />
        </div>
        <div className="card-div">
          <div className="frame-div39">
            <img className="school-icon" alt="" src="../teacher1.svg" />
          </div>
          <b className="parent-b">Teacher</b>
          <div className="frame-div40">
            <div className="the-parent-will-be-responsible">
              <p className="the-parent-will">
                Qualified, experienced and highly
              </p>
              <p className="the-parent-will">{`motivated tutors to teach the `}</p>
              <p className="children-p">students</p>
            </div>
          </div>
          <Form.Check
            className="ellipse-formcheck"
            name="step1"
            id="step1"
            type="radio"
          />
        </div>
        <div className="card-div">
          <div className="frame-div39">
            <img className="school-icon" alt="" src="../parentmentor2.svg" />
          </div>
          <b className="parent-b">Mentor</b>
          <div className="frame-div40">
            <div className="the-parent-will-be-responsible">
              <p className="the-parent-will">{`An industry expert, willing to `}</p>
              <p className="the-parent-will">volunteer to mentor teachers,</p>
              <p className="children-p">parents or students</p>
            </div>
          </div>
          <Form.Check
            className="ellipse-formcheck"
            name="step1"
            id="step1"
            type="radio"
          />
        </div>
      </div>
      <div className="frame-div47">
        <div
          className="skip-i-already-have-a-shuleea"
          onClick={onSkipIAlreadyClick}
        >
          Skip, I already have a ShuleEazy account
        </div>
        <button
          className="buttondesktopprimary5"
          onClick={onButtonDesktopPrimaryClick}
        >
          <b className="save-and-next6"> NEXT</b>
        </button>
      </div>
      <button
        className="buttondesktopsecondary1"
        onClick={onButtonDesktopSecondaryClick}
      >
        <button className="buttondesktopsecondary2">
          <b className="save-and-next7">RESET</b>
        </button>
      </button>
    </div>
  );
};

export default Step1;
